import React, { useState } from 'react';
import { useAppContext } from '../../context/AppContext';
import { TelehealthExportModule } from './TelehealthModule';

const Telehealth = () => {
  const { state } = useAppContext();
  const { currentUser } = state;
  const [activeTab, setActiveTab] = useState('overview');

  return (
    <div className="space-y-6">
      {TelehealthExportModule.renderTelehealthDashboard({ currentUser, activeTab, setActiveTab })}
    </div>
  );
};

export default Telehealth;
